export default __webpack_public_path__ + "static/feranmi-nifries-82cce619334c31103e84d81b82ce43e1.png";